module.exports = __webpack_public_path__ + "img/inter-5.17dc78e4.jpg";